import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import {
  required,
  maxLength,
  minLength,
  numeric,
  maxValue,
  minValue
} from "vuelidate/lib/validators";
import ValidationService from '@/services/ValidationService';

export default {
  name: "HostelEdit",
  components: {
    MainLayout,
    Loading,
  },
  mixins: [ValidationService],
  data() {
    return {
      hostelData: {},
      isTeacherIncharge: false,
      teacherList: [],
      submitted: false,
      isLoading: false,
      disabled: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isInitializing: true,
    };
  },

  validations: {
    hostelData: {
      name: {
        required,
        maxLength: maxLength(255)
      },
      type: {
        required,
      },
      capacity: {
        required,
        numeric,
        minValue: minValue(1),
        maxValue: maxValue(100)
      },
      incharge_name: {
        required,
        maxLength: maxLength(255)
      },
      incharge_ph_no: {
        numeric,
        minLength: minLength(8),
        maxLength: maxLength(11)
      }
    },
  },

  watch: {
    isTeacherIncharge(newValue) {
      if (this.isInitializing) return;
      this.submitted = false;
      if (newValue) {
        this.hostelData.incharge_name = '';
        this.getTeachers();
      } else {
        this.hostelData.incharge_teacher_id = null;
        this.hostelData.incharge_name = '';
        this.hostelData.incharge_ph_no = '';
      }
    },
    'hostelData.incharge_teacher_id': function (newVal) {
      if (newVal) {
        const selectedTeacher = this.teacherList.find(teacher => teacher.id === newVal);
        if (selectedTeacher) {
          this.hostelData.incharge_name = selectedTeacher.name;
          this.hostelData.incharge_ph_no = selectedTeacher.phone1;
        }
      } else {
        this.hostelData.incharge_name = '';
        this.hostelData.incharge_ph_no = '';
      }
    }
  },

  methods: {
    getTeachers() {
      return axios.get('hostel/teachers');
    },

    getDetail() {
      return axios.get(`hostel/detail/${this.$route.params.id}`);
    },

    update() {
      if (this.disabled) return;
      this.submitted = true;

      if (this.$v.$invalid) {
        this.validationErrors = {};
        return;
      }

      this.disabled = true;
      this.isLoading = true;

      const postData = { ...this.hostelData };
      // Include `incharge_teacher_id` in the payload so backend can sync boarders

      axios.patch(`hostel/update/${this.$route.params.id}`, postData)
        .then(res => {
          if (res.data) {
            this.$notification.success("Hostel Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'hostelList'
            })
          } else {
            this.disabled = false;
            this.isLoading = false;
            this.$notification.error("Something went wrong", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          this.printValidationError(error.response);
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
          }
        });
    }
  },

  mounted() {
    this.isLoading = true;
    Promise.all([this.getDetail(), this.getTeachers()])
      .then(([detailRes, teachersRes]) => {
        if (detailRes.data) {
          this.hostelData = detailRes.data;
        }
        this.teacherList = teachersRes.data;

        const matchedTeacher = this.teacherList.find(teacher =>
          teacher.name === this.hostelData.incharge_name &&
          teacher.phone1 === this.hostelData.incharge_ph_no
        );

        if (matchedTeacher) {
          this.isTeacherIncharge = true;
          this.$set(this.hostelData, 'incharge_teacher_id', matchedTeacher.id);
        }
      })
      .catch(error => {
        console.error("Error loading page data:", error);
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
      })
      .finally(() => {
        this.isLoading = false;
        this.isInitializing = false;
      });
  },
};
